// extracted by mini-css-extract-plugin
export default {"main":"SiteInfo_main__4p-CL"};